
angular.module('component-payments.format.cvc', [])
	.directive('ctPaymentsFormatCvc', ['CtUtils', paymentsFormatCvcDirective]);

function paymentsFormatCvcDirective (CtUtils) {
	return {
		restrict: 'A',
		require: 'ngModel',
		link: function (scope, element, attr) {
			element.on('keypress', onKeyPress);

			function onKeyPress(e) {
				var char = CtUtils.getChar(e);

				if (!char.match(/./)) {
					return;
				}

				if (!char.match(/\d/)) {
					e.preventDefault();
				}
			}
		}
	}
}

module.exports = 'component-payments.format.cvc';


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/ct-payments/formatters/cvc.js
 ** module id = 88
 ** module chunks = 1
 **/